<!-- 抄表管理 -->
<template>
    <div class="index-main">
        <a-row style="height: 100%;positive: relative">
            <a-col :span="6" class="cell-left">
                <a-row style="height: 100%">
                    <a-col :span="24" style="height: 35%">
                        <faultAnalysis ref="faultAnalysisRef" :titleImage="titleImage"></faultAnalysis>
                    </a-col>
                    <a-col :span="24" style="height: 30%">
                        <MeterReadingSizeMeterNumAndOnline ref="MeterReadingSizeMeterNumAndOnlineRef"></MeterReadingSizeMeterNumAndOnline>
                    </a-col>
                    <a-col :span="24" style="height: 35%">
                        <MeterCommunityRate ref="MeterCommunityRateRef" />
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="12" style="height: 100%;">
                <a-row style="height: 100%;margin-left: 5px;margin-right: 5px">
                    <a-col :span="24" style="height: 65%;position: relative">
                        <!-- <MeterReadingCenter ref="MeterReadingCenterRef" /> -->
                         <MeterRealingCenter ref="MeterRealingCenterRef"/>
                    </a-col>
                    <a-col :span="24" style="height: 35%;position: relative">
                        <a-col :span="12" style="height: 100%;padding: 0 10px;">
                            <MeterManufacturerTotal ref="MeterManufacturerTotalRef" />
                        </a-col>
                        <a-col :span="12" style="height: 100%;padding: 0 10px;">
                            <MeterReadingOnlineAndFault ref="MeterReadingOnlineAndFaultRef"></MeterReadingOnlineAndFault>
                        </a-col>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="6" class="cell-right">
                <a-row style="height: 100%">
                    <a-col :span="24" style="height: 33%">
                      <MeterReadingIndex ref="MeterReadingIndexRef" :titleImage="titleImage"/>
                    </a-col>
                    <a-col :span="24" style="height: 32%">
                      <MeterReadingLargeUsers ref="MeterReadingLargeUsersRef" :titleImage="titleImage"/>
                    </a-col>
                    <a-col :span="24" style="height: 35%">
                      <!-- <MeterReadingAmountOfWater ref="MeterReadingAmountOfWaterRef" :titleImage="titleImage"/> -->
                      <MeterRealTimeAlarmList ref="MeterRealTimeAlarmListRef" />
                    </a-col>
                </a-row>
            </a-col>
        </a-row>
    </div>
</template>
<script>
import faultAnalysis from './modules/faultAnalysis'
import MeterReadingOnlineAndFault from './modules/MeterReadingOnlineAndFault'
import MeterReadingSizeMeterNumAndOnline from './modules/MeterReadingSizeMeterNumAndOnline'
// import echartMap from './modules/echartMap'
import MeterReadingCenter from './modules/MeterReadingCenter'
import MeterReadingAmountOfWater from './modules/MeterReadingAmountOfWater.vue'
import MeterReadingIndex from './modules/MeterReadingIndex.vue'
import MeterReadingLargeUsers from './modules/MeterReadingLargeUsers.vue'
import MeterRealingCenter from './modules/MeterRealingCenter.vue'
import MeterManufacturerTotal from './modules/MeterManufacturerTotal.vue'
import MeterCommunityRate from './modules/MeterCommunityRate.vue'
import MeterRealTimeAlarmList from './modules/MeterRealTimeAlarmList.vue'
export default {
    components: {
        faultAnalysis,
        MeterReadingOnlineAndFault,
        MeterReadingSizeMeterNumAndOnline,
        MeterReadingCenter,
        MeterReadingAmountOfWater,
        MeterReadingIndex,
        MeterReadingLargeUsers,
        MeterRealingCenter,
        MeterManufacturerTotal,
        MeterCommunityRate,
        MeterRealTimeAlarmList
    },
    data() {
        return {
            titleImage:require("@/assets/images/title-gradual.png"),
        }
    },
    mounted() {
        this.$nextTick(()=> {
            this.init()
        })
    },
    methods: {
        init() {
            this.$refs.faultAnalysisRef.init()
            this.$refs.MeterReadingOnlineAndFaultRef.init()
            this.$refs.MeterReadingSizeMeterNumAndOnlineRef.init()
            // this.$refs.MeterReadingCenterRef.init()
            // this.$refs.MeterReadingAmountOfWaterRef.init()
            this.$refs.MeterReadingIndexRef.init()
            this.$refs.MeterReadingLargeUsersRef.init()
            this.$refs.MeterRealingCenterRef.init()
            this.$refs.MeterManufacturerTotalRef.init();
            this.$refs.MeterCommunityRateRef.init();
            this.$refs.MeterRealTimeAlarmListRef.init();
        }
    }
}
</script>
<style lang="less" scoped>
.index-main{
    height: 100%;
    padding: 12px;
}
.cell-left,.cell-right{
    height: 100%;
    padding-left: 12px;
    padding-right: 12px;
    //position: absolute;
}
.cell-bottom{
    height: 30%;
    //position: absolute;
    background: url('~@/assets/images/cell-bottom.png') no-repeat;
    background-size: 100% 100%;
}
.cell-left{
    top: 0;
    left: 0;
}
.cell-right{
    top: 0;
    right: 0;
}
.cell-bottom{
    bottom: 0;
    height: 30%;
}
/* 每块内容的样式 */
.index-main{
    /deep/ .m-panel{
        color: #B6DEFF;
        height: 100%;
    }
    /deep/ .m-panel-bar{
        height: 40px;
    }
    /deep/ .m-panel-bar-title{
        font-size: 18px;
        font-weight: 700;
        color: #B6DEFF;
        display: flex;
        align-items: center;
        padding-left: 7px;
        border-bottom: 5px solid transparent; /* 创建透明的下边框 */
        border-image: url('~@/assets/images/title-gradual.png') 5 stretch; /* 指定图像路径、重复次数和对齐方式 */
        border-image-repeat: stretch;
    }
    /deep/ .m-panel-body{
        height: calc(100% - 40px)
    }
    /deep/ .total-sum{
        color: #A8C6F3;
        font-weight: bold;
        font-size: 33px;
        margin-top: 33px;
    }
    /deep/ .unit{
        font-size: 12px;
        color: #A8C6F3;
        margin-left: 5px;
    }
    /deep/ .m-total{
        padding: 10px;
        line-height: 1;
        
        .total-title{
            color: #01B8FD;
            font-weight: 500;
            font-size: 16px;
        }
        .total-type-title{
            color: #B6DEFF;
        }
    }
    /deep/ .font-24{
        font-size: 24px;
    }
    /deep/ .flex-center{
        display: flex;
        align-items: center;
    }
}
.cell-left{
    position: relative;
    background: url('~@/assets/images/cell-left.png') no-repeat;
    background-size: 100% 100%;
}
.cell-right{
    position: relative;
    background: url('~@/assets/images/cell-right.png') no-repeat;
    background-size: 100% 100%;
}
</style>